/**
 * Utility functions and data for country code handling
 */

// Map of ISO country codes to country names
export const countryCodeToName: Record<string, string> = {
  // Major wine-producing countries
  'FR': 'France',
  'IT': 'Italy',
  'ES': 'Spain',
  'US': 'United States',
  'AR': 'Argentina',
  'CL': 'Chile',
  'AU': 'Australia',
  'NZ': 'New Zealand',
  'ZA': 'South Africa',
  'PT': 'Portugal',
  'DE': 'Germany',
  'AT': 'Austria',
  'GR': 'Greece',
  'HU': 'Hungary',
  'CA': 'Canada',
  
  // Europe
  'GB': 'United Kingdom',
  'IE': 'Ireland',
  'BE': 'Belgium',
  'NL': 'Netherlands',
  'CH': 'Switzerland',
  'HR': 'Croatia',
  'SI': 'Slovenia',
  'BG': 'Bulgaria',
  'RO': 'Romania',
  'CZ': 'Czech Republic',
  'SK': 'Slovakia',
  'PL': 'Poland',
  'MD': 'Moldova',
  'UA': 'Ukraine',
  'RS': 'Serbia',
  'ME': 'Montenegro',
  'MK': 'North Macedonia',
  'AL': 'Albania',
  'CY': 'Cyprus',
  'MT': 'Malta',
  'GE': 'Georgia',
  'AM': 'Armenia',
  'FI': 'Finland',
  'DK': 'Denmark',
  'SE': 'Sweden',
  'NO': 'Norway',
  'IS': 'Iceland',
  'LU': 'Luxembourg',
  'TR': 'Turkey',
  
  // Americas
  'BR': 'Brazil',
  'MX': 'Mexico',
  'UY': 'Uruguay',
  'PE': 'Peru',
  'CO': 'Colombia',
  'EC': 'Ecuador',
  'VE': 'Venezuela',
  'GT': 'Guatemala',
  'PA': 'Panama',
  'CR': 'Costa Rica',
  'NI': 'Nicaragua',
  'BZ': 'Belize',
  'CU': 'Cuba',
  'DO': 'Dominican Republic',
  'HT': 'Haiti',
  'JM': 'Jamaica',
  'GY': 'Guyana',
  'BB': 'Barbados',
  'TT': 'Trinidad and Tobago',
  'LC': 'Saint Lucia',
  'AG': 'Antigua and Barbuda',
  'GD': 'Grenada',
  'BM': 'Bermuda',
  'AI': 'Anguilla',
  'PR': 'Puerto Rico',
  'MQ': 'Martinique',
  'GP': 'Guadeloupe',
  'RE': 'Reunion',
  
  // Asia & Oceania
  'JP': 'Japan',
  'CN': 'China',
  'IN': 'India',
  'TH': 'Thailand',
  'KR': 'Republic of Korea',
  'TW': 'Taiwan',
  'HK': 'Hong Kong',
  'PH': 'Philippines',
  'ID': 'Indonesia',
  'KH': 'Cambodia',
  'VN': 'Vietnam',
  'FJ': 'Fiji',
  'MU': 'Mauritius',
  'SC': 'Seychelles',
  'SG': 'Singapore',
  
  // Middle East & Africa
  'IL': 'Israel',
  'LB': 'Lebanon',
  'SY': 'Syria',
  'MA': 'Morocco',
  'TN': 'Tunisia',
  'DZ': 'Algeria',
  'EG': 'Egypt',
  'KE': 'Kenya',
  'NG': 'Nigeria',
  
  // Other
  'RU': 'Russian Federation',
  'GG': 'Guernsey',
  'BA': 'Bosnia and Herzegovina'
};

/**
 * Get the country name from an ISO country code
 * @param code ISO country code (e.g., 'FR', 'IT')
 * @returns The country name or the original code if not found
 */
export const getCountryName = (code: string): string => {
  return countryCodeToName[code] || code;
};
